module.exports = __webpack_public_path__ + "static/tesla-logo-small-b544945b94ea1c1f40acf3e4ea0033a5.png";